import React from 'react';

type TagMap = {
  [key: string]: (children: React.ReactNode, isRoot?: boolean, key?: string) => JSX.Element;
};

const tagMap: TagMap = {
  red: (children, _isRoot, key) => (
    <span key={key} className="text-statusDanger">
      {children}
    </span>
  ),
  black: (children, _isRoot, key) => (
    <span key={key} className="text-black">
      {children}
    </span>
  ),
  bold: (children, _isRoot, key) => (
    <span key={key} className="font-bold">
      {children}
    </span>
  ),
  semibold: (children, isRoot, key) =>
    isRoot ? (
      <div key={key} className="font-semibold">
        {children}
      </div>
    ) : (
      <span key={key} className="font-semibold">
        {children}
      </span>
    ),
  span: (children, _isRoot, key) => <span key={key}>{children}</span>,
  p: (children, _isRoot, key) => <p key={key}>{children}</p>,
  div: (children, _isRoot, key) => <div key={key}>{children}</div>,
  br: (_children, _isRoot, key) => <br key={key} />,
};

export function renderCustomTags(input: string): React.ReactNode {
  const tagRegex = /<(\/?)([a-zA-Z0-9-]+)(\s*\/?)>/g;

  function parseTokens(text: string, isRoot = false, keyPrefix = ''): React.ReactNode[] {
    const stack: { tag: string; children: React.ReactNode[] }[] = [];
    const result: React.ReactNode[] = [];
    let lastIndex = 0;
    let elementIndex = 0;

    let match: RegExpExecArray | null;
    while ((match = tagRegex.exec(text)) !== null) {
      const [fullMatch, closingSlash, tagName, selfClose] = match;
      const matchIndex = match.index;
      const tag = tagName.toLowerCase();

      const beforeText = text.slice(lastIndex, matchIndex);
      if (beforeText) {
        (stack.length ? stack[stack.length - 1].children : result).push(beforeText);
      }

      lastIndex = tagRegex.lastIndex;

      const key = `${keyPrefix}-${elementIndex++}`;

      if (selfClose || fullMatch.endsWith('/>')) {
        const element = tagMap[tag]?.(null, false, key);
        if (element) {
          (stack.length ? stack[stack.length - 1].children : result).push(element);
        } else {
          (stack.length ? stack[stack.length - 1].children : result).push(fullMatch);
        }
      } else if (!closingSlash) {
        stack.push({ tag, children: [] });
      } else {
        const last = stack.pop();
        if (last && last.tag === tag) {
          const rendered = tagMap[tag] ? tagMap[tag](last.children, isRoot && result.length === 0 && stack.length === 0, key) : fullMatch;
          (stack.length ? stack[stack.length - 1].children : result).push(rendered);
        } else {
          (stack.length ? stack[stack.length - 1].children : result).push(fullMatch);
        }
      }
    }

    const remaining = text.slice(lastIndex);
    if (remaining) {
      (stack.length ? stack[stack.length - 1].children : result).push(remaining);
    }

    return result;
  }
  return <>{parseTokens(input, true, 'root')}</>;
}
